export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  return age >= 0 ? age : null;
}

export function startOfWeek(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function sameDay(a, b) {
  const x = new Date(a);
  const y = new Date(b);
  return (
    x.getFullYear() === y.getFullYear() &&
    x.getMonth() === y.getMonth() &&
    x.getDate() === y.getDate()
  );
}

export function toDateKey(d) {
  const x = new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function startOfMonth(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(1);
  return d;
}

export function endOfMonth(date) {
  const d = startOfMonth(date);
  d.setMonth(d.getMonth() + 1);
  d.setDate(0);
  return d;
}

export function monthGridDays(anchor) {
  const first = startOfMonth(anchor);
  const start = startOfWeek(first);
  return Array.from({ length: 42 }, (_, i) => addDays(start, i));
}

export function isSameMonth(a, b) {
  const x = new Date(a);
  const y = new Date(b);
  return x.getFullYear() === y.getFullYear() && x.getMonth() === y.getMonth();
}

export function hoursUntil(iso) {
  return (new Date(iso).getTime() - Date.now()) / (1000 * 60 * 60);
}

export function formatExpiryAlert(dateStr, label) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return null;
  const days = Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  const masculine = label === "Абонемент" || label === "Допуск";
  if (days < 0) {
    return {
      tone: "danger",
      text: `${label} ${masculine ? "просрочен" : "просрочена"}`,
    };
  }
  if (days === 0) return { tone: "warn", text: `${label} истекает сегодня` };
  if (days <= 7) return { tone: "warn", text: `${label} истекает через ${days} дн.` };
  return null;
}

/** Имя из ФИО: «Фамилия Имя Отчество» → «Имя» */
export function givenNameFromFullName(fullName) {
  const parts = String(fullName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return parts[1];
  return parts[0] || "";
}

/** Краткое имя для ленты и профилей: «Фамилия Имя Отчество» → «Имя Фамилия» */
export function personDisplayName(fullName) {
  const parts = String(fullName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return `${parts[1]} ${parts[0]}`;
  return parts[0] || "";
}

/** «Фамилия Имя Отчество» → «Имя Отчество» (для чата с тренером). */
export function personGivenAndPatronymic(fullName) {
  const parts = String(fullName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 3) return `${parts[1]} ${parts[2]}`;
  if (parts.length === 2) return parts[1];
  return parts[0] || "";
}

/** Заголовок личного чата с тренером(ами) клуба. */
export function trainerPersonalChatTitle(trainersOrName) {
  if (typeof trainersOrName === "string") {
    return personGivenAndPatronymic(trainersOrName) || "Тренер";
  }
  const list = Array.isArray(trainersOrName) ? trainersOrName : [];
  if (list.length === 1) {
    const name = list[0]?.full_name || list[0]?.name || list[0];
    return personGivenAndPatronymic(name) || "Тренер";
  }
  return "Тренер";
}
